/**
 * Domain Intelligence DTOs
 *
 * Zod schemas for duplicate business detection request/response.
 *
 * @see Issue #TBD - Domain Intelligence & Duplicate Business Detection
 */

import { z } from 'zod';

/**
 * Request schema for checking duplicate businesses.
 * Used by self-signup, admin portal, and partner onboarding flows.
 */
export const CheckDuplicateBusinessRequestSchema = z.object({
  email: z.string().email(),
  companyName: z.string().optional(),
  einNumber: z.string().optional(),
  realmId: z.string().uuid().optional(), // Omit for platform-wide check
});

export type CheckDuplicateBusinessRequest = z.infer<typeof CheckDuplicateBusinessRequestSchema>;

/**
 * A single duplicate match with confidence scoring.
 */
export const DuplicateMatchSchema = z.object({
  businessId: z.string().uuid(),
  businessName: z.string(),
  realmId: z.string().uuid(),
  matchReasons: z.array(z.enum(['domain', 'ein', 'name_exact'])),
  confidence: z.enum(['high', 'medium', 'low']),
});

export type DuplicateMatch = z.infer<typeof DuplicateMatchSchema>;

/**
 * Response schema for duplicate business check.
 */
export const CheckDuplicateBusinessResponseSchema = z.object({
  hasDuplicates: z.boolean(),
  matches: z.array(DuplicateMatchSchema),
});

export type CheckDuplicateBusinessResponse = z.infer<typeof CheckDuplicateBusinessResponseSchema>;
